/*
 * School Management System API
 * APIs for managing branches, employees, students, receipts, etc.
 *
 * OpenAPI spec version: 1.0.0
 * Contact: tejabhargavpodila@gmail.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 3.0.54
 *
 * Do not edit the class manually.
 *
 */
import ApiClient from '../ApiClient';

/**
 * The ReceiptCreateRequest model module.
 * @module model/ReceiptCreateRequest
 * @version 1.0.0
 */
export default class ReceiptCreateRequest {
  /**
   * Constructs a new <code>ReceiptCreateRequest</code>.
   * @alias module:model/ReceiptCreateRequest
   * @class
   */
  constructor() {
  }

  /**
   * Constructs a <code>ReceiptCreateRequest</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/ReceiptCreateRequest} obj Optional instance to populate.
   * @return {module:model/ReceiptCreateRequest} The populated <code>ReceiptCreateRequest</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new ReceiptCreateRequest();
      if (data.hasOwnProperty('applicationNumber'))
        obj.applicationNumber = ApiClient.convertToType(data['applicationNumber'], 'String');
      if (data.hasOwnProperty('feeType'))
        obj.feeType = ApiClient.convertToType(data['feeType'], 'String');
      if (data.hasOwnProperty('amount'))
        obj.amount = ApiClient.convertToType(data['amount'], 'Number');
      if (data.hasOwnProperty('modeOfPayment'))
        obj.modeOfPayment = ApiClient.convertToType(data['modeOfPayment'], 'String');
      if (data.hasOwnProperty('chequeNumber'))
        obj.chequeNumber = ApiClient.convertToType(data['chequeNumber'], 'String');
      if (data.hasOwnProperty('dateOfPayment'))
        obj.dateOfPayment = ApiClient.convertToType(data['dateOfPayment'], 'String');
    }
    return obj;
  }
}

/**
 * @member {String} applicationNumber
 */
ReceiptCreateRequest.prototype.applicationNumber = undefined;

/**
 * Allowed values for the <code>feeType</code> property.
 * @enum {String}
 * @readonly
 */
ReceiptCreateRequest.FeeTypeEnum = {
  /**
   * value: "firstYearTuitionFee"
   * @const
   */
  firstYearTuitionFee: "firstYearTuitionFee",

  /**
   * value: "firstYearHostelFee"
   * @const
   */
  firstYearHostelFee: "firstYearHostelFee",

  /**
   * value: "secondYearTuitionFee"
   * @const
   */
  secondYearTuitionFee: "secondYearTuitionFee",

  /**
   * value: "secondYearHostelFee"
   * @const
   */
  secondYearHostelFee: "secondYearHostelFee"
};
/**
 * @member {module:model/ReceiptCreateRequest.FeeTypeEnum} feeType
 */
ReceiptCreateRequest.prototype.feeType = undefined;

/**
 * @member {Number} amount
 */
ReceiptCreateRequest.prototype.amount = undefined;

/**
 * @member {String} modeOfPayment
 */
ReceiptCreateRequest.prototype.modeOfPayment = undefined;

/**
 * @member {String} chequeNumber
 */
ReceiptCreateRequest.prototype.chequeNumber = undefined;

/**
 * @member {String} dateOfPayment
 */
ReceiptCreateRequest.prototype.dateOfPayment = undefined;

